import Vue from 'vue'

export default new Vue()

// import eventModule from '@/assets/libs/eventModule'
// eventModule.$emit('eventName', eventData)
// created() {
//     eventModule.$on('eventName', this.callback)
// },
// beforeDestroy() {
//     eventModule.$off('eventName', this.callback);
// },



// WEBPACK FOOTER //
// ./src/assets/libs/eventModule.js